import { isCategoryMetas } from '@/app/(plp)/_utils/type-guards';
import { useBasicMetas } from '@/app/(plp)/_utils/use-basic-metas';
import usePLPData from '@/app/(plp)/_utils/use-plp-data';
import { usePLPFacetsContext } from '@/app/(plp)/facets-context/facets-context';
import DesktopCategories from './desktop';
import NextLevelCategoriesLoading from './loading';
import MobileCategories from './mobile';
import { getNextLevelCategoies } from '../../utils/category-helpers';
interface Props {
  mode: 'desktop' | 'mobile';
}
export const NextLevelCategories = ({
  mode
}: Props) => {
  const {
    page
  } = usePLPFacetsContext();
  const {
    basicMetas,
    isLoadingBasicMetas
  } = useBasicMetas();
  const {
    pageResponse,
    isLoadingFirstPage,
    isPending
  } = usePLPData();
  const {
    totalCount = 0
  } = pageResponse?.products || {};
  const hasResults = totalCount > 0;
  const isLoading = isPending || isLoadingFirstPage || isLoadingBasicMetas;
  const categoryBasicMeta = isCategoryMetas(page, basicMetas) ? basicMetas : undefined;
  const categories = pageResponse?.facets?.categories || undefined;
  const nextLevelCategories = getNextLevelCategoies(categories, categoryBasicMeta?.nameEn || undefined);
  if (isLoading) return <NextLevelCategoriesLoading />;
  if (!nextLevelCategories || !nextLevelCategories?.length || !hasResults) return null;
  return mode === 'desktop' ? <DesktopCategories categories={nextLevelCategories} title={categoryBasicMeta?.nameFa || ''} data-sentry-element="DesktopCategories" data-sentry-component="NextLevelCategories" data-sentry-source-file="next-level-categories.tsx" /> : <MobileCategories categories={nextLevelCategories} data-sentry-element="MobileCategories" data-sentry-component="NextLevelCategories" data-sentry-source-file="next-level-categories.tsx" />;
};
export default NextLevelCategories;